const state = {
  evaluationTypeStatistics: [],
  isLoadingEvaluationTypeStatistics: true
};

const getters = {
  evaluationTypeStatisticsShowable: ({ evaluationTypeStatistics }) => {
    const totalCount = evaluationTypeStatistics
      .flatMap(item => item.options)
      .map(option => option.count)
      .reduce((acc, count) => acc + count, 0);

    return !!totalCount;
  }
};

const mutations = {
  SET_EVALUATION_TYPE_STATISTICS(state, evaluationTypeStatistics) {
    state.evaluationTypeStatistics = evaluationTypeStatistics;
  },
  SET_IS_LOADING_EVALUATION_TYPE_STATISTICS(
    state,
    isLoadingEvaluationTypeStatistics
  ) {
    state.isLoadingEvaluationTypeStatistics = isLoadingEvaluationTypeStatistics;
  }
};

const actions = {
  fetchEvaluationTypeStatistics({ commit, rootState }) {
    const product_code = rootState.productCode;
    commit('SET_IS_LOADING_EVALUATION_TYPE_STATISTICS', true);
    rootState.api
      .fetchEvaluationTypeStatistics(product_code)
      .then(({ data }) => {
        commit(
          'SET_EVALUATION_TYPE_STATISTICS',
          data.evaluation_type_statistics
        );
      })
      .finally(() =>
        commit('SET_IS_LOADING_EVALUATION_TYPE_STATISTICS', false)
      );
  }
};

export default { namespaced: true, state, getters, mutations, actions };
